<div #chartWrapper [attr.id]="_containerId" [ngClass]="parentComponent" class="tv-chart-container"></div>
